export default {
  items: [
    {
      name: 'Home',
      // url: '/dashboard',
      icon: 'icon-home',
      children : [
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-home',
        },
        {
          name: 'Account Settings',
          url: '/profile',
          icon: 'icon-settings'
        },
        {
          name: 'Orders',
          url: '/orders',
          icon: 'fa fa-dollar'
        },
      ]
    },
    {
      name: 'Calendar',
      url: '/calendar',
      icon: 'icon-calendar'
    },
    {
      name: 'Clients',
      // url: '/nutritionist/clients',
      icon: 'icon-people',
      children : [
        {
          name: 'Add Client',
          url: '/nutritionist/clients/add',
          icon: 'icon-user-follow'
        },
        {
          name: 'Client List',
          url: '/nutritionist/clients',
          icon: 'icon-people',
        },
        {
          name: 'SendEmail',
          url: '/send-email',
          icon: 'fa fa-envelope-o'
        },

      ]
    },
    {
        name: 'Weeks',
        icon: 'icon-calendar',
        children: [
          {
              name: 'All Weeks',
              url: '/nutritionist/weeks',
              icon: 'icon-calendar'
          },
          {
              name: 'Client Weeks',
              url: '/nutritionist/client-weeks',
              icon: 'icon-people'
          },
        ]
    },
    {
      name: 'Menus',
      // url: '/nutritionist/menus',
      icon: 'icon-layers',
      children: [
        {
          name: 'All Menus',
          url: '/nutritionist/menus',
          icon: 'icon-layers',          
        },
        {
          name: 'Create Menu',
          url: '/nutritionist/create-menu',
          icon: 'icon-layers'
        },
      ]
    },
    {
      name: 'Tools',
      icon: 'icon-settings',
      children : [
        {
          name: 'BMI',
          url: '/bmi',
          icon: 'icon-calculator'
        },
        {
          name: 'Calculators',
          url: '/calculator',
          icon: 'icon-calculator'
        },
        {
          name: 'Diets',
          url: '/diets',
          icon: 'icon-layers'
        },
      ]
    },
    {
      name: "B2B",
      icon: 'icon-wallet',
      children: [
        {
          name: 'Specialists',
          url: '/specialists',
          icon: 'icon-briefcase'
        },
        {
          name: 'My Shop',
          url: '/shop',
          icon: 'icon-basket-loaded'
        },
      ]
    },
    {
      name: 'News',
      url: '/news',
      icon: 'fa fa-info-circle'
    },
    {
      name: 'About Us',
      url: '/about',
      icon: 'fa fa-info'
    },
    {
      name: 'How to',
      url: '/how-to',
      icon: 'fa fa-info-circle'
    },
  ]
}
